import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import {
  addFeaturedEventSettings,
  getFeaturedEvents,
  getFeaturedEventSettings,
} from "../../../FeaturedEventsService";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";

function FeatureSettingsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "90%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();
  const [realTimeData, setRealTimeData] = useState(false);
  const [hideSection, setHideSection] = useState(false);
  const [numberOfEvents, setNumberOfEvents] = useState(0);
  const [noEventsMessage, setNoEventsMessage] = useState("");
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const saveSettings = () => {
    let data = {
      ClientId: selectCareersClient.id,
      UseRealTimeData: realTimeData,
      MaxDisplayCount: numberOfEvents,
      NoCountMessage: noEventsMessage,
      HideSection: hideSection,
    };

    callAPI(
      addFeaturedEventSettings(data),
      "Settings Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  };

  useEffect(() => {
    if (selectCareersClient !== null) {
      getFeaturedEventSettings(selectCareersClient.id).then((response) => {
        setRealTimeData(response.useRealTimeData);
        setHideSection(response.hideSection);
        setNumberOfEvents(response.maxDisplayCount);
        setNoEventsMessage(response.noCountMessage);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className={classes.root}>
        <Grid className={classes.cardContainer}>
          <Card className={classes.card}>
            <CardContent>
              <Grid container spacing={1}>
                <Grid xs={12} sm={6} item>
                  <FormControlLabel
                    className={classes.copy}
                    control={
                      <Checkbox
                        color="primary"
                        checked={realTimeData}
                        onChange={() => setRealTimeData(!realTimeData)}
                      />
                    }
                    label="Use Real Time Data"
                  />
                </Grid>
                <Grid xs={12} sm={6} item>
                  <FormControlLabel
                    className={classes.copy}
                    control={
                      <Checkbox
                        color="primary"
                        checked={hideSection}
                        onChange={() => setHideSection(!hideSection)}
                      />
                    }
                    label="Hide section if none available"
                  />
                </Grid>
                <Grid xs={12} sm={12} item>
                  <TextField
                    placeholder="Total number of events to display (max: 10)"
                    label="Total number of events to display (max: 10)"
                    variant="standard"
                    type="number"
                    fullWidth
                    required
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={numberOfEvents}
                    onChange={(e) => setNumberOfEvents(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    placeholder="No events message"
                    label="No events message"
                    variant="standard"
                    fullWidth
                    required
                    InputProps={{
                      className: classes.copy,
                    }}
                    value={noEventsMessage}
                    onChange={(e) => setNoEventsMessage(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} container justifyContent="flex-end">
                  <Button
                    style={{ marginTop: "20px", marginRight: "8px" }}
                    className={classes.sensitiveButton}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => saveSettings()}
                  >
                    Save Information
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </>
  );
}

export default FeatureSettingsPage;
